import LabeledContent from "./LabeledContent";

export default LabeledContent;
